import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimesCircle, 
  faRedoAlt, 
  faHome, 
  faQuestionCircle, 
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/PaymentResult.css';
import { useTranslation } from 'react-i18next';

const PaymentFail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const errorMessage = location.state?.errorMessage || t('payment.paymentFailedDesc');

  // 返回上一页重试
  const handleRetry = () => {
    navigate(-1);
  };

  // 常见失败原因
  const commonFailureReasons = [
    '余额不足，请确保您的账户有足够的资金',
    '网络连接不稳定，请检查您的网络连接',
    '银行系统繁忙，请稍后再试',
    '支付信息填写有误，请重新核对信息'
  ];

  return (
    <div className="home-page">
      <Header />
      <div className="payment-result-container payment-fail">
        <div className="payment-result-icon">
          <FontAwesomeIcon icon={faTimesCircle} />
        </div>
        
        <div className="payment-result-header">
          <h1>{t('payment.paymentFailedTitle')}</h1>
          <p className="payment-result-message">
            {errorMessage}
          </p>
        </div>
        
        <div className="payment-details">
          <h2>
            <FontAwesomeIcon icon={faQuestionCircle} /> {t('payment.commonFailureReasons')}
          </h2>
          <ul style={{ textAlign: 'left', paddingLeft: '20px' }}>
            {commonFailureReasons.map((reason, index) => (
              <li key={index} style={{ marginBottom: '8px' }}>{reason}</li>
            ))}
          </ul>
        </div>
        
        <div className="payment-actions">
          <button onClick={handleRetry} className="payment-btn btn-primary">
            <FontAwesomeIcon icon={faRedoAlt} /> {t('payment.retryBtn')}
          </button>
          <Link to="/" className="payment-btn btn-secondary">
            <FontAwesomeIcon icon={faHome} /> {t('payment.homeBtn')}
          </Link>
        </div>
        
        <div className="payment-tips">
          <p>{t('payment.paymentFailedDesc')}</p>
          <p>{t('payment.retryPaymentDesc')}</p>
          <p>{t('payment.contactSupportDesc')}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
